import { render, staticRenderFns } from "./ProcesoForm2.vue?vue&type=template&id=1db62962"
import script from "./ProcesoForm2.vue?vue&type=script&lang=js"
export * from "./ProcesoForm2.vue?vue&type=script&lang=js"
import style0 from "./ProcesoForm2.vue?vue&type=style&index=0&id=1db62962&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports